// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { AppConfig } from "./ConfigTypes";
import appConfigOverrides from "../config/AppConfigOverrides";

// DO NOT MODIFY THIS FOR YOUR VERSION OF THE APP
// USE AppConfigOverrides.ts INSTEAD.
const MasterConfig: AppConfig = {
  cameraEnabled: true,
  cameraFullScreenEnabled: true,
  cameraLiveMLRecognitionEnabled: true,
  cameraOverlayEnabled: true,
  cameraTimer: 5000,

  staticPhotoMLRecognitionEnabled: true,

  customerConfigs: [],

  // BE CAREFUL WHEN SETTING THIS TO FALSE!
  // This will remove the warning displayed when you're about to
  // schedule a fedex pickup in the production front-end.
  // Warnings will always show in all other environments.
  showFedExAPIWarningInProd: true,

  // This will enable fedex pickup in production.
  enableFedExPickupInProd: false,
};

export const getAppConfig = (): AppConfig => {
  return { ...MasterConfig, ...appConfigOverrides };
};
